import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TableMultiSelectInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        let title = this.props.header?.information?.fields?.title ?? 'name'

        return (
            <div className="w-100 h-100 flexc" style={{ overflow: 'hidden' }}>
                {this.props.data && Array.isArray(this.props.data) && (
                    <div className={'flexc'} style={{}}>
                        {this.props.data.map((prop, index) => {
                            return (
                                <div key={index} className="mrd-1 mb-1" style={{ backgroundColor: prop.colors?.background ?? '#f0f0f0', borderRadius: 20, padding: '6px 14px' }}>
                                    <p className="text-smaller" style={{ color: prop.colors?.color ?? '#202020', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap' }}>{prop[title]}</p>
                                </div>
                            )
                        })}
                    </div>
                )}

                {this.props.data && !Array.isArray(this.props.data) && (
                    <div className={'flexc'} style={{}}>

                        <p className="" style={{ color: this.props.data.colors?.color ?? '#202020', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap' }}>{this.props.data[title]}</p>

                    </div>
                )}
            </div>
        )
    }
}

export default TableMultiSelectInput;